<div class="field">
    <label [for]="inputId()">{{ label() }}</label>
    <cl-input-date [inputId]="inputId()" [formControl]="control()" [min]="min()" [max]="max()" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
